import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const AlertFilterBar = ({ filters, onFilterChange, onClearFilters }) => {
  const severityOptions = [
    { value: 'all', label: 'All Severities' },
    { value: 'critical', label: 'Critical' },
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' }
  ];

  const zoneOptions = [
    { value: 'all', label: 'All Zones' },
    { value: 'Core Zone', label: 'Core Zone' },
    { value: 'Buffer Zone', label: 'Buffer Zone' },
    { value: 'Transition Zone', label: 'Transition Zone' },
    { value: 'Visitor Center', label: 'Visitor Center' },
    { value: 'Trail Network', label: 'Trail Network' }
  ];

  const typeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'weather', label: 'Weather' },
    { value: 'wildlife', label: 'Wildlife' },
    { value: 'safety', label: 'Safety' },
    { value: 'facility', label: 'Facility' },
    { value: 'environmental', label: 'Environmental' }
  ];

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation mb-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Select
          label="Severity"
          options={severityOptions}
          value={filters?.severity}
          onChange={(value) => onFilterChange('severity', value)}
        />
        
        <Select
          label="Zone"
          options={zoneOptions}
          value={filters?.zone}
          onChange={(value) => onFilterChange('zone', value)}
        />
        
        <Select
          label="Alert Type"
          options={typeOptions}
          value={filters?.type}
          onChange={(value) => onFilterChange('type', value)}
        />
        
        <div className="flex items-end">
          <Button
            variant="outline"
            fullWidth
            iconName="X"
            onClick={onClearFilters}
          >
            Clear Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AlertFilterBar;